import React, { useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { Panel, PanelBody, PanelHeader, PanelFooter } from "../../components/panel/panel.jsx";
import { useSelector, useDispatch } from "react-redux";
import TablaDetalle from "./components/TablaDetalle";
import TableShimmer from "../../components/table/TableShimmer.js";
import EmptyTableMessage from "../../components/table/EmptyTableMessage.js";
import SweetAlert from "react-bootstrap-sweetalert";

import _ from "lodash";
import { useEffectAsync } from "../../helper/reactHelper";
import { comprobanteActions } from "../../store";

import { formatDate, formatMoney, getStatusComprobante } from "../../helper/formatter";
import BuildComprobante from "./components/BuildComprobante.js";

const DatosTercero = () => {
    const { comprobante_id } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    let buildComprobante = BuildComprobante();

    const comprobante = useSelector((state) => state.comprobante?.items[comprobante_id]) || null;

    const pagos = useSelector((state) => state.pago.items) || null;
    const tercero = useSelector((state) => state.tercero.items[comprobante?.terceroId]);

    const [loading, setLoading] = useState(false);
    const [detalleComprobante, setDetalleComprobante] = useState([]);
    const [comprobantePago, setComprobantePago] = useState([]);
    const [verComprobante, setVerComprobante] = useState(false);
    const [warn, setWarn] = useState({});

    useEffectAsync(async () => {
        if (comprobante_id != 0) {
            try {
                setLoading(true);
                const responseDetalleComprobante = await fetch(`/api/comprobante/${comprobante_id}/DetalleComprobante`);
                const responseComprobantePago = await fetch(`/api/comprobante/${comprobante_id}/ComprobantePago`);

                if (responseDetalleComprobante.ok) {
                    setDetalleComprobante(
                        _(await responseDetalleComprobante.json())
                            .sortBy("linea")
                            .value()
                    );
                    setVerComprobante(true);
                } else {
                    throw Error(await responseDetalleComprobante.text());
                }

                if (responseComprobantePago.ok) {
                    setComprobantePago(await responseComprobantePago.json());
                } else {
                    throw Error(await responseComprobantePago.text());
                }
            } finally {
                setLoading(false);
            }
        }
    }, [comprobante_id]);

    const handleAnular = async (value) => {
        const response = await fetch("/api/comprobante/anular", {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ comprobantesIds: comprobante_id, anular: value }),
        });

        if (response.ok) {
            let newComprobante = { ...comprobante };
            newComprobante.anulado = value;
            dispatch(comprobanteActions.update(newComprobante));
        } else {
            throw Error(await response.text());
        }
    };

    const handleVerComprobante = () => {
        buildComprobante({ ...comprobante, ["detalle_comprobantes"]: detalleComprobante });
    };

    const handleEliminarComprobante = async () => {
        const response = await fetch("/api/comprobante/" + comprobante_id, { method: "DELETE" });
        if (response.ok) {
            dispatch(comprobanteActions.delete({ id: comprobante_id }));
            history.push("/venta/facturas_emitidas");
        } else {
            throw Error(await response.text());
        }
    };

    const eliminarComprobanteDialog = () => {
        setWarn({
            message: `Esta seguro que desea eliminar este comprobante de forma permanente`,
        });
    };

    const handleAbono = () => {
        if (comprobante) {
            history.push({
                pathname: "/venta/registro_cobros/0",
                state: {
                    comprobantes: [comprobante],
                },
            });
        }
    };

    return (
        <div>
            <Panel>
                {!_.isEmpty(warn) && (
                    <SweetAlert
                        danger
                        showCancel
                        confirmBtnText="Continuar"
                        cancelBtnText="Cancelar"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Eliminar comprobante"
                        onConfirm={() => handleEliminarComprobante()}
                        onCancel={() => setWarn({})}>
                        {warn.message}
                    </SweetAlert>
                )}

                <PanelHeader>
                    COMPROBANTE: {comprobante?.talonario?.serie}
                    {comprobante?.n_comprobante}
                </PanelHeader>
                <PanelBody>
                    <div className="row">
                        <div className="col-md-6 pe-4 mb-5">
                            <div className="row p-1 fs-4">
                                <div className="col-md-4 fw-bold ">RAZON SOCIAL: </div>
                                <div className="col-md-8">
                                    <Link to={`/tercero/${comprobante?.terceroId}`} className="fw-bold text-nowrap">
                                        {tercero?.razonsocial}
                                    </Link>
                                </div>
                            </div>
                            <div className="row p-1">
                                <div className="col-md-4 fw-bold ">FECHA EMISION: </div>
                                <div className="col-md-8">{formatDate(comprobante?.fecha_emision)}</div>
                            </div>
                            <div className="row p-1">
                                <div className="col-md-4 fw-bold ">DIAS DE CREDITO: </div>
                                <div className="col-md-8">{comprobante?.dias_credito}</div>
                            </div>
                            <div className="row  p-1">
                                <div className="col-md-4 fw-bold">FECHA LIMITE PAGO:</div>
                                <div className="col-md-8">{formatDate(comprobante?.fecha_vencimiento)}</div>
                            </div>
                            <div className="row  p-1">
                                <div className="col-md-4 fw-bold">NOTAS:</div>
                                <div className="col-md-8">{comprobante?.notas}</div>
                            </div>

                            <div className="shadow fs-11px">
                                <TablaDetalle detalle={detalleComprobante} loading={loading} />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row mb-2">
                                <div className="col-md-12 text-end">{getStatusComprobante(comprobante, "fs-5")}</div>
                            </div>

                            <div className="row p-2 ">
                                <div className="col-md-6 col-8 fw-bold ">BASE IMPONIBLE: </div>
                                <div className="col-md-6 col-4">{formatMoney(comprobante?.suma_venta_sujeta)}</div>
                            </div>
                            <div className="row p-2 ">
                                <div className="col-md-6 col-8 fw-bold ">( + ) IMPORTE IVA: </div>
                                <div className="col-md-6 col-4">{formatMoney(comprobante?.iva)}</div>
                            </div>
                            <div className="row p-2 ">
                                <div className="col-md-6 col-8 fw-bold ">( - ) IMPORTE RETENCION: </div>
                                <div className="col-md-6 col-4">{formatMoney(comprobante?.retencion)}</div>
                            </div>

                            <div className="row p-2 ">
                                <div className="col-md-6 col-8 fw-bold ">( + ) IMPORTE EXCENTO: </div>
                                <div className="col-md-6 col-4">{formatMoney(comprobante?.suma_venta_excenta)}</div>
                            </div>

                            <div className="row p-2 ">
                                <div className="col-md-6 col-8 fw-bold ">( + ) IMPORTE NO SUJETO: </div>
                                <div className="col-md-6 col-4">{formatMoney(comprobante?.suma_venta_no_sujeta)}</div>
                            </div>

                            <div className="row border-top p-2 fs-4">
                                <div className="col-md-6 col-8 fw-bold ">( = ) IMPORTE TOTAL: </div>
                                <div className="col-md-6 col-4 fw-bold">{formatMoney(comprobante?.importe)}</div>
                            </div>

                            <br />

                            <div className="row">
                                <div className="table-responsive">
                                    <table
                                        className={
                                            "table table-bordered widget-table align-middle rounded table-sm " +
                                            (!loading && " table-hover table-striped")
                                        }>
                                        <thead>
                                            <tr className="text-nowrap">
                                                <th>#</th>
                                                <th>PAGO</th>
                                                <th>FECHA</th>
                                                <th>TIPO PAGO</th>
                                                <th className="text-end">MONTO</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {!loading ? (
                                                comprobantePago.length > 0 ? (
                                                    comprobantePago.map((cp, i) => (
                                                        <tr key={i}>
                                                            <td>{i + 1}</td>
                                                            <td>
                                                                <Link
                                                                    to={`/venta/registro_cobros/${cp.pagoId}`}
                                                                    className="fw-bold text-nowrap">
                                                                    PAGO-{cp.pagoId}
                                                                </Link>
                                                            </td>
                                                            <td>{formatDate(pagos[cp.pagoId]?.fecha_emision)}</td>
                                                            <td> {pagos[cp.pagoId]?.tipo_pago?.name} </td>
                                                            <td className="text-nowrap text-end">{formatMoney(cp.monto)}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <EmptyTableMessage columns={5} />
                                                )
                                            ) : (
                                                <TableShimmer columns={5} enableAnimation />
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="row p-2">
                                <div className="col-md-8   text-end text-gray">YA PAGADO: </div>
                                <div className="col-md-4 fw-bold text-end">
                                    {formatMoney(comprobante?.importe - comprobante?.pendiente)}
                                </div>
                            </div>
                            <div className="row p-2">
                                <div className="col-md-8   text-end text-gray">( - ) FACTURADO: </div>
                                <div className="col-md-4 fw-bold text-end">{formatMoney(comprobante?.importe)}</div>
                            </div>
                            <div className="row p-2 fs-2">
                                <div className="col-md-8 fw-bold text-end">RESTA POR PAGAR: </div>
                                <div className="col-md-4 fw-bold text-end text-red-600">
                                    {formatMoney(comprobante?.pendiente)}
                                </div>
                            </div>
                        </div>
                    </div>
                </PanelBody>

                <PanelFooter className="text-center">
                    <button className="btn btn-default btn-lg ms-5px mb-2" onClick={() => history.goBack()}>
                        Atras
                    </button>

                    <button className="btn btn-warning btn-lg ms-5px mb-2" onClick={() => handleAnular(!comprobante.anulado)}>
                        {comprobante?.anulado ? "Revertir anulacion" : "Anular"}
                    </button>

                    <Link
                        to={`/venta/registrar_factura?comprobanteId=${comprobante_id}`}
                        className="btn btn-primary btn-lg ms-5px mb-2">
                        Copiar
                    </Link>

                    <button
                        disabled={comprobante?.anulado || +comprobante?.pendiente <= 0}
                        className="btn btn-lime btn-lg ms-5px mb-2"
                        onClick={() => handleAbono()}>
                        Abonar
                    </button>

                    <button
                        disabled={!verComprobante}
                        className="btn btn-indigo btn-lg ms-5px mb-2"
                        onClick={() => handleVerComprobante()}>
                        Ver / Re-imprimir
                    </button>

                    <br />

                    <button className="btn btn-danger btn-lg ms-5px mb-2" onClick={() => eliminarComprobanteDialog()}>
                        Eliminar comprobante
                    </button>
                </PanelFooter>
            </Panel>
        </div>
    );
};

export default DatosTercero;
